import React, { useState } from "react";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CommonModal from "../../ResetContext/components/DumpModal";
import { useAppServices } from "../../../../../hook/services";
import toast from "react-hot-toast";

// You should get your publishable key from env or props

const PaymentForm = ({ onClose, agency, setRefetch, userActiveLocation }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const service = useAppServices();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!stripe || !elements) {
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);

    // Create payment method with billing details
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name,
        email,
      },
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    const { response } =
      await service.subscription.updatePaymentMethodByAgencyId({
        payload: {
          id: paymentMethod.id,
          agency_id: agency?._id,
          customer_id: userActiveLocation?.customer_id,
        },
      });
    if (response?.data) {
      toast.success("Payment method updated successfully!");
      setLoading(false);
      onClose();
      setRefetch && setRefetch((r) => !r);
      return;
    }
    toast.error("Something went wrong");
    setLoading(false);
    onClose();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="block text-sm mb-1">Name</label>
        <input
          type="text"
          className="w-full border rounded px-2 py-1"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="block text-sm mb-1">Email</label>
        <input
          type="email"
          className="w-full border rounded px-2 py-1"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div style={{ margin: "16px 0" }}>
        <CardElement options={{ hidePostalCode: true }} />
      </div>
      {error && <div style={{ color: "red" }}>{error}</div>}
      <button
        type="submit"
        disabled={!stripe || loading}
        className="w-full bg-black text-white py-2 mt-2 rounded"
      >
        {loading ? "Saving..." : "Save Payment Method"}
      </button>
    </form>
  );
};

const EditPaymentMethod = ({
  isOpen,
  onClose,
  title,
  agency,
  setRefetch,
  userActiveLocation,
}) => {
  if (!agency?.stripe?.publish_key) {
    return (
      <CommonModal
        title={title}
        showAlert={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        <div className="p-4">
          <p className="text-red-500">Stripe publish key is not available.</p>
        </div>
      </CommonModal>
    );
  }
  const stripePromise = loadStripe(agency?.stripe?.publish_key);
  return (
    <CommonModal
      title={title}
      showAlert={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Elements stripe={stripePromise}>
        <PaymentForm
          onClose={onClose}
          agency={agency}
          setRefetch={setRefetch}
          userActiveLocation={userActiveLocation}
        />
      </Elements>
    </CommonModal>
  );
};

export default EditPaymentMethod;
